<template>
  <AppBar title="Login" />
  <v-container>
    <v-card>
      <v-card-text>
        <v-btn :to="{ name: '/local-login' }">local login</v-btn>
      </v-card-text>
    </v-card>
    <v-card v-for="token in currentAccounts" :key="token.server">
      <v-card-title>{{ token.server }}</v-card-title>
      <v-card-text>
        <v-btn :to="{ params: { server: token.server }, name: '/user' }"
          >user</v-btn
        >
        <v-btn @click="to_repo_list(token.server)">repositories</v-btn>
      </v-card-text>
    </v-card>
    <div>{{ localAccount }}</div>
    <v-card>
      <v-card-text>
        <ForgejoSiteEntry v-model="forgejoSite" />
        <form ref="form" @submit.prevent="login()">
          <v-text-field
            v-model="username"
            label="username"
            name="username"
            placeholder="username"
            required
            type="text"
          />
          <v-text-field
            v-model="password"
            label="password"
            name="password"
            placeholder="password"
            required
            type="password"
          />
          <v-btn
            color="primary"
            :disabled="submitDisabled"
            type="submit"
            value="log in"
            >Login</v-btn
          >
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import type { Ref } from "vue";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import {
  currentAccounts,
  localAccount,
  setAccount,
  setActiveAccount,
} from "../authenticationTokens";
import { userCreateToken, userGetCurrent } from "../gen/forgejo-vue";

const router = useRouter();

const forgejoSite: Ref<string> = ref("");
const username = ref("");
const password = ref("");
const submitDisabled = computed(() => {
  return !(forgejoSite.value && username.value && password.value);
});

async function login() {
  if (submitDisabled.value) {
    return;
  }
  const authorization = "Basic " + btoa(`${username.value}:${password.value}`);
  // create a string to make the token name unique
  const dateSuffix = new Date()
    .toISOString()
    .slice(0, 19)
    .replace(":", "-")
    .replace(":", "-");
  const options = {
    baseURL: forgejoSite.value + "/api/v1/",
    headers: { Authorization: authorization },
  };
  const token = await userCreateToken(
    username.value,
    {
      name: `todomvp-${dateSuffix}`,
      scopes: [
        "read:user",
        "read:repository",
        "write:repository",
        "read:issue",
        "write:issue",
      ],
    },
    options,
  );
  const { name, sha1 } = token.data;
  const r = await userGetCurrent(options);
  if (name && sha1 && r.data.id) {
    setAccount({
      server: forgejoSite.value,
      token_name: name,
      token: sha1,
      username: username.value,
      uid: r.data.id,
      enabled: true,
      repositories: [],
    });
  }
}

function to_repo_list(server: string) {
  setActiveAccount(server);
  void router.push({
    name: "/repos/",
  });
}
</script>
